import { useMutation } from '@tanstack/react-query';
import type {
	ConfirmationToken,
	Stripe,
	StripeElements,
	StripeError,
} from '@stripe/stripe-js';

/**
 * Turns the card the Payment Element collected into a Stripe ConfirmationToken,
 * so the payment can be confirmed later without the element mounted.
 *
 * Note - this wraps a method from Stripe's SDK. This is not a method from the LW core api
 */
const useStripeCreateConfirmationToken = (
	stripe: Stripe | null,
	elements: StripeElements | null,
) => {
	return useMutation<ConfirmationToken, StripeError | Error, void>({
		mutationFn: async () => {
			if (!stripe) {
				throw new Error('stripe is not defined');
			}

			if (!elements) {
				throw new Error('elements is not defined');
			}

			const result = await stripe.createConfirmationToken({ elements });

			if (result.error) {
				throw result.error;
			}

			return result.confirmationToken;
		},
	});
};

export default useStripeCreateConfirmationToken;
